
<Modal :mayCancel="true" v-on:done="onDone" v-on:cancel="onDone">
  <p>
    In order to upload images to Browserboard, you need to be logged in. This
    limitation exists to keep the site free.
  </p>
  <div class="ButtonRow-FlexRight">
    <div></div>
    <SignupButton></SignupButton>
  </div>
</Modal>
